export default __webpack_public_path__ + "025a7da782f419450e48ee96120f64fd.png";